export default __webpack_public_path__ + "static/Actions-Schedule-4efac06148258119977898fdaca253c1.jpg";